// extracted by mini-css-extract-plugin
export default {"categories__container":"Categories_categories__container__3jM9w"};